module.exports = __webpack_public_path__ + "static/assets/79d4855beb75548e069ea84efe393b65.svg";